import React, {Component} from 'react';
import "../CSS/appointment.css"
import ProgressBarElement from "../Components/ProgressBarElement.js"
import CirclePlus from '../images/CirclePlus.svg'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export default class LocationAddModal extends Component {
  constructor(props){
    super(props)
  }
  render() {
    return (
      <div>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">New Location</h5>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group ">
                  <input className="form-control" type="text" id="location_name" placeholder="Location Name"></input>
                </div>
                <div className="form-group">
                  <input className="form-control" type="text" id="address_1" placeholder="Address Line 1"></input>
                </div>
                <div className="form-row mb-3">
                  <div className="col">
                    <input className="form-control form-control-md" type="text" id="address_2" placeholder="Address 2"></input>
                  </div>
                  <div className="col">
                    <input className="form-control form-control-md" type="text" id="city" placeholder="City"></input>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col">
                    <input className="form-control form-control-md" type="text" id="state" placeholder="State"></input>
                  </div>
                  <div className="col">
                    <input className="form-control form-control-md" type="text" id="zip" placeholder="Zip"></input>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button className="btn btn-danger text-white" onClick={this.props.closeModal}>Cancel</button>
              <button className="btn btn-success" data-dismiss="modal">Save Location</button>
            </div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/LocationAddModal.js